<template>
  <main class="container-fluid" :class="{ 'boxPadding': isBox }">
    <form class="form">
      <section class="segment">
        <h4 class="text-green mt-0">個人資訊</h4>
        <div class="row">
          <div class="col-12">
            <div class="form-group row">
              <label for="client-name" class="col-2 text-right">姓名</label>
              <div class="col-10 d-flex">
                <input type="text" maxlength="50" id="client-name" name="client-name" placeholder="客戶姓名"
                  class="form-control" v-model="form.name" alt="ch" @input="checkInputName" @blur="checkInputName" />
                <span class="waring-block d-inline-block ml-2">
                  <span class="text"><span class="text-red">＊</span>必填</span>
                </span>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group row">
              <label for="wg_name" class="col-2 text-right">原住民姓名(拼音)</label>
              <div class="col-10">
                <input type="text" maxlength="100" id="wg_name" name="wg_name" placeholder="原住民姓名(拼音)"
                  class="form-control" v-model="form.wg_name" @input="checkInputWgName" @blur="checkInputWgName" />
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="client-identity" class="col-4 text-right">性別</label>
              <div class="col-8">
                <div class="radio radio-inline">
                  <input type="radio" name="gender" id="gender-1" v-model="form.gender" value="1">
                  <label for="gender-1">男</label>
                </div>
                <div class="radio radio-inline">
                  <input type="radio" name="gender" id="gender-2" v-model="form.gender" value="2">
                  <label for="gender-2">女</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="client-birth-year" class="col-4 text-right">生日</label>
              <div class="col-8">
                <select @change="computeBirAge(form.birthday[0], form.birthday[1], form.birthday[2])" name="birth_year"
                  :class="{ 'is-invalid': isBirdayError }" d="client-birth-year"
                  class="form-control form-control-inline" v-model="form.birthday[0]">
                  <option value="">年份</option>
                  <option v-for="(opt, y_opt_i) in birthYearOpt" :key="`birth-year-${y_opt_i}`" :value="opt">{{ opt -
                    1911 }}年</option>
                </select>

                <span class="text">/</span>

                <select @change="computeBirAge(form.birthday[0], form.birthday[1], form.birthday[2])" name="birth_year"
                  :class="{ 'is-invalid': isBirdayError }" d="client-birth-year"
                  class="form-control form-control-inline" v-model="form.birthday[1]">
                  <option value="">月份</option>
                  <option v-for="(opt, m_opt_i) in birthMonthOpt" :key="`birth-month-${m_opt_i}`" :value="opt">{{ opt
                  }}月
                  </option>
                </select>

                <span class="text">/</span>

                <select @change="computeBirAge(form.birthday[0], form.birthday[1], form.birthday[2])" name="birth_year"
                  :class="{ 'is-invalid': isBirdayError }" d="client-birth-year"
                  class="form-control form-control-inline" v-model="form.birthday[2]">
                  <option value="">日期</option>
                  <option v-for="(opt, d_opt_i) in birthDateOpt" :key="`birth-date-${d_opt_i}`" :value="opt">{{ opt }}日
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="client-identity" class="col-4 text-right">ID</label>
              <div class="col-8">
                <input type="text" id="client-identity" name="identityID" class="form-control form-control-inline"
                  placeholder="身分證字號" maxlength="10" v-model="form.identityID" />
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="client-age" class="col-4 text-right">年齡</label>
              <div class="col-8">
                <input type="text" maxlength="3" @input="numberAge" id="client-age" name="age"
                  class="form-control form-control-inline" placeholder="年齡" v-model="form.age" :disabled="agedisable">
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="segment">
        <h4 class="text-green d-inline-block mt-0">聯絡資訊</h4>
        <!--<span class="waring-block d-inline-block text-center ml-3 mb-3">
          <span class="text"><span class="text-red">＊</span>
          聯絡資訊為必填，四項請選擇一項填寫，謝謝</span>
        </span>-->
        <div class="row">
          <div class="col-6">
            <div class="form-group row">
              <label for="client-lineID" class="col-4 text-right">LINE ID</label>
              <div class="col-8">
                <input type="text" maxlength="20" id="client-lineID" name="line_id" placeholder="LINE ID"
                  class="form-control form-control-inline" v-model="form.lineid" @input="checkInputLineID" />
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="client-mobile" class="col-4 text-right">手機</label>
              <div class="col-8">
                <input type="tel" maxlength="20" @input="numberMobile" id="client-mobile" name="mobile" placeholder="號碼"
                  class="form-control form-control-inline" v-model="form.mobile">
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="client-phone" class="col-4 text-right">住家電話</label>
              <div class="col-8">
                <input type="tel" maxlength="4" @input="numberPhone0" id="client-phone"
                  class="form-control form-control-inline form-short" placeholder="區碼" v-model="form.phone[0]">
                <span class="text">-</span>
                <input type="tel" maxlength="20" @input="numberPhone1" placeholder="電話號碼"
                  class="form-control form-control-inline" v-model="form.phone[1]">
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="client-office_phone" class="col-4 text-right">公司電話</label>
              <div class="col-8">
                <input type="tel" maxlength="4" @input="numberOffice_phone0" id="client-office_phone"
                  class="form-control form-control-inline form-short" placeholder="區碼" v-model="form.office_phone[0]">
                <span class="text">-</span>
                <input type="tel" maxlength="15" @input="numberOffice_phone1" placeholder="電話號碼"
                  class="form-control form-control-inline" v-model="form.office_phone[1]">
                <span class="text">#</span>
                <input type="tel" maxlength="10" @input="numberOffice_phone2"
                  class="form-control form-control-inline form-short" placeholder="分機" v-model="form.office_phone[2]">
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="segment">
        <h4 class="text-green mt-0">基本資料</h4>
        <div class="row">
          <div class="col-6">
            <div class="form-group row">
              <label for="client-email" class="col-4 text-right">Email</label>
              <div class="col-8">
                <input type="text" maxlength="50" id="client-email" name="email" placeholder="電子信箱" class="form-control"
                  v-model="form.email" @input="checkInputEmail" />
              </div>
            </div>
          </div>
          <!-- <div class="row">
          <div class="col-6">
            <div class="form-group row">
              <label for="client-email" class="col-4 text-right">Email</label>
              <div class="col-8">
                <input type="text"
                id="client-email"
                name="email"
                placeholder="電子信箱"
                class="form-control"
                v-validate="'required|email'"
                v-model="form.email">
                <span class="text-red">{{ errors.first('email') }}</span>
              </div>
            </div>
          </div> -->
          <div class="col-6">
            <div class="form-group row">
              <label for="client-introducer" class="col-4 text-right">介紹人</label>
              <div class="col-8">
                <!-- <input type="text"
                v-show="form.introducerId == ''"
                id="client-introducer"
                name="introducer"
                placeholder="姓名"
                class="form-control form-control-inline"
                v-model="form.introducer"> -->
                <b v-show="form.introducerId !== ''" class="text px-3 text-green">{{ form.introducer }}</b>
                <a class="btn btn-red m-0" v-if="form.introducerId !== ''" @click="deleteIntr">
                  刪除
                </a>
                <a class="btn btn-default m-0" v-else @click="panelOpen('clientSearchOpen')">
                  從既有客戶查詢
                </a>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="client-fax" class="col-4 text-right">傳真</label>
              <div class="col-8">
                <input type="tel" maxlength="4" @input="numberFax_area" id="client-fax"
                  class="form-control form-control-inline form-short" placeholder="區碼" v-model="form.fax_area">
                <span class="text">-</span>
                <input type="tel" maxlength="20" @input="numberFax" placeholder="電話號碼"
                  class="form-control form-control-inline" v-model="form.fax">
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="gender-1" class="col-4 text-right">學歷</label>
              <div class="col-8">
                <select class="form-control form-control-inline form-wide" v-model="form.education">
                  <option value="">請選擇</option>
                  <option v-for="(e, eid) in eduOpt" :key="`city-item-${eid}`" :value="e.val">{{ e.text }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="gender-1" class="col-4 text-right">職業分類</label>
              <div class="col-8">
                <!--<select class="form-control form-control-inline form-large" v-model="form.career">
                  <option value="">請選擇</option>
                  <option
                  v-for="(c, cid) in careerOpt"
                  :key="`city-item-${cid}`"
                  :value="c.val">{{c.text}}</option>
                </select>-->
                <b v-if="form.career" class="text px-3 text-green">第{{ form.careerCategory }}類 {{ form.career_name
                }}</b>
                <a class="btn btn-default m-0" @click="jobPickingOpen = true">請選擇</a>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="gender-1" class="col-4 text-right">婚姻</label>
              <div class="col-8">
                <select class="form-control form-control-inline form-wide" v-model="form.marriage">
                  <option value="">請選擇</option>
                  <option v-for="(m, mid) in marriageOpt" :key="`city-item-${mid}`" :value="m.val">{{ m.text }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="gender-1" class="col-4 text-right">服務單位</label>
              <div class="col-8">
                <input type="text" maxlength="30" class="form-control form-control-inline" v-model="form.agency"
                  @input="checkInputAgency" @blur="checkInputAgency">
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="gender-1" class="col-4 text-right">居住狀況</label>
              <div class="col-8">
                <div class="row">
                  <div class="col-6">
                    <select class="form-control" v-model="form.housing_status">
                      <option value="">請選擇</option>
                      <option v-for="(h, hid) in housingStatusOpt" :key="`city-item-${hid}`" :value="h.val">{{ h.text }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row mx-0">
              <label for="gender-1" class="col-4 text-right">現居地址</label>
              <div class="col-8">
                <div class="row">
                  <div class="col-6">
                    <select class="form-control" v-model="form.address[0]" @change="changeCity('address')">
                      <option value="">縣市</option>
                      <option v-for="(city, cid) in cityOpt" :key="`city-item-${cid}`" :value="city">{{ city }}</option>
                    </select>
                  </div>
                  <div class="col-6">
                    <select class="form-control" :disabled="form.address[0] === ''" v-model="form.address[1]">
                      <option value="">區</option>
                      <option v-for="(area, aid) in areaOpt" :key="`area-item-${aid}`" :value="area.area">{{ area.area
                      }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <input type="text" name="address" class="form-control" placeholder="地址" maxlength="50"
              :disabled="form.address && form.address[1] === ''" v-model="form.address[2]" alt="ch"
              @input="checkInputAddress" @blur="checkInputAddress" />
          </div>
          <div class="col-6">
            <div class="form-group row mx-0">
              <label for="gender-1" class="col-4 text-right">公司地址</label>
              <div class="col-8">
                <div class="row">
                  <div class="col-6">
                    <select class="form-control" v-model="form.office_address[0]"
                      @change="changeCity('office_address')">
                      <option value="">縣市</option>
                      <option v-for="(city, cid) in officeCityOpt" :key="`city-item-${cid}`" :value="city">{{ city }}
                      </option>
                    </select>
                  </div>
                  <div class="col-6">
                    <select class="form-control" :disabled="form.office_address && form.office_address[0] === ''"
                      v-model="form.office_address[1]">
                      <option value="">區</option>
                      <option v-for="(area, aid) in officeAreaOpt" :key="`area-item-${aid}`" :value="area.area">
                        {{ area.area }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <input type="text" name="office_address" class="form-control" placeholder="地址" maxlength="50"
              :disabled="form.office_address && form.office_address[1] === ''" v-model="form.office_address[2]" alt="ch"
              @input="checkInputOfficeAddress" @blur="checkInputOfficeAddress" />
          </div>
        </div>
      </section>
      <section class="segment">
        <h4 class="text-green mt-0">財務狀況</h4>
        <div class="row">
          <div class="col-6">
            <div class="form-group row">
              <label for="gender-1" class="col-4 text-right">家庭年收入</label>
              <div class="col-8">
                <select class="form-control form-control-inline form-wide" v-model="form.household_income">
                  <option value="">請選擇</option>
                  <option v-for="(c, cid) in householdOpt" :key="`household-item-${cid}`" :value="c.val">{{ c.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="birth-year" class="col-4 text-right">房貸金額</label>
              <div class="col-8">
                <input type="tel" maxlength="10" class="form-control form-control-inline form-short"
                  @input="numberHouseloan" v-model="form.houseloan">
                <span class="text">萬</span>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="gender-1" class="col-4 text-right">個人年所得</label>
              <div class="col-8">
                <select class="form-control form-control-inline form-wide" v-model="form.personal_income">
                  <option value="">請選擇</option>
                  <option v-for="(c, cid) in personalOpt" :key="`city-item-${cid}`" :value="c.val">{{ c.text }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="gender-1" class="col-4 text-right">住宅權屬</label>
              <div class="col-8">
                <select class="form-control form-control-inline form-wide" v-model="form.housing">
                  <option value="">請選擇</option>
                  <option v-for="(c, cid) in housingOpt" :key="`housing-item-${cid}`" :value="c.val">{{ c.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="gender-1" class="col-4 text-right">月平均投資</label>
              <div class="col-8">
                <select class="form-control form-control-inline form-wide" v-model="form.monthly_invest">
                  <option value="">請選擇</option>
                  <option v-for="(c, cid) in investOpt" :key="`invest-item-${cid}`" :value="c.val">{{ c.text }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
              <label for="gender-1" class="col-4 text-right">交通工具</label>
              <div class="col-8">
                <select class="form-control form-control-inline form-wide" v-model="form.vehicle">
                  <option value="">請選擇</option>
                  <option v-for="(e, eid) in vehicleOpt" :key="`vehicle-item-${eid}`" :value="e.val">{{ e.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group row">
              <label for="gender-1" class="col-2 text-right">理財工具</label>
              <div class="col-10">
                <div class="checkbox checkbox-inline" v-for="(tool, tid) in tools" :key="`tool-item-${tid}`">
                  <input type="checkbox" v-model="form.finance_tool" :id="`tool-item-${tid}`" :value="tool.val">
                  <label :for="`tool-item-${tid}`">{{ tool.text }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="segment">
        <h4 class="text-green mt-0">群組資訊</h4>
        <div class="row">
          <div class="col-12">
            <a @click="panelOpen('confirmGroupModalOpen')" class="btn btn-border-green ml-0">
              <i class="icon-add_new"></i>
            </a>
            <div class="btn btn-border-green px-3" v-for="(g, gid) in form.group" :key="`form-group-${gid}`">
              {{ g.grp_name }}
              <a class="close" @click="removeGroupItem(gid)">
                <i class="icon-close"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section class="segment">
        <h4 class="text-green mt-0" id="familyAnchor">家戶資訊</h4>
        <div class="row">
          <div class="col-12">
            <div v-if="!addFamily.newFamilyId">
              <a @click="doAddFamily" class="btn btn-border-green ml-0">
                <i class="icon-add_new"></i>
              </a>
            </div>
            <div class="col-10" v-else>
              <span>戶長姓名</span>
              <span class="text-green padding-25">{{ addFamily.familyName }}</span>
              <button type="button" class="btn btn-red" @click="doCleanFamily">刪除</button>
            </div>
          </div>
        </div>
      </section>
      <section class="segment">
        <h4 class="text-green mt-0">備註</h4>
        <div class="row">
          <div class="col-12">
            <div class="form-group row">
              <div class="col-10 d-flex">
                <textarea v-model="form.memo" class="form-control" rows="10" maxlength="400" @input="checkInputMemo"
                  @blur="checkInputMemo">
                </textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="action text-right">
        <button @click.stop.prevent="initData()" type="submit" class="btn btn-default">
          清空資料
        </button>
        <button @click.stop.prevent="doSubmit()" type="submit" class="btn btn-primary">
          新增客戶
        </button>
      </div>
    </form>

    <search-client-modal :open="clientSearchOpen" @submit="submitClient" @close="panelClose('clientSearchOpen')" />

    <group-modal :open="groupModalOpen" :custs="[form.identityID]" :currentPage="'customerCreate'" @submit="submitGroup"
      @close="panelClose('groupModalOpen')" />

    <validation-modal :open="validModalOpen" @close="panelClose('validModalOpen')" />

    <job-picking-modal :open="jobPickingOpen" @submit="submitJob" @close="jobPickingOpen = false" />

    <!-- 確認加入群組類型視窗 -->
    <confirm-group-modal :open="confirmGroupModalOpen" @close="panelClose('confirmGroupModalOpen')"
      @addToCurrentGroup="addToCurrentGroup" @createNewGroup="createNewGroup" />

    <!-- 加入現有群組視窗 -->
    <add-to-group-new-modal type="CustomerCreateUse" :open="addToGroupNewModalOpen" :allGroup="grpsOfAgnt"
      :selectedGroup="form.group" @submit="addToGrpSubmit" @close="panelClose('addToGroupNewModalOpen')" />

    <!-- 成立新的群組視窗 -->
    <group-new-modal type="CustomerCreateUse" source="CustomerCreate" :open="groupNewModalOpen" :allGroup="grpsOfAgnt"
      :selectedGroup="form.group" @submit="groupSubmit" @close="panelClose('groupNewModalOpen')" />

    <!-- 確認加入群組類型視窗 -->
    <confirm-family-modal :open="confirmFamilyModalOpen" @close="panelClose('confirmFamilyModalOpen')"
      @addToCurrentFamily="addToCurrentFamily" @createNewFamily="createNewFamily" />

    <!-- 加入現有家戶視窗 -->
    <add-to-family-new-modal type="CustomerCreateUse" :open="addToFamilyNewModalOpen" :allFamily="familyOfAgnt"
      :newCust="newCust" @submit="addToFamilySubmit" @close="panelClose('addToFamilyNewModalOpen')" />

    <warning-modal :open="warningModalOpen" :message="warningMessage" :showCancel="false"
      @submit="panelClose('warningModalOpen')" @send="openSendEmailModal" @close="doBack" @download="download" />

    <send-email-modal :open="sendEmailModalOpen" :isBnk="false" :senderName="$store.state.userInfo.name"
      @close="closeEmailModal" @doSendEmail="doSendEmail" />

  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { commonMixin } from '../../mixins/common'
import SearchClientModal from '../components/SearchClientModal'
import GroupModal from '../components/GroupModal'
import ValidationModal from '../components/ValidationModal'
import { queryDistByCity } from '../../service'
import { addNewCust, computeAge, AddLatAndLnt, getGroupOfAgnt, getAllHouseholderBySales, addMembersToFamily, createNewFamily, addCustInfoLog, sendDataCollectionEmail, downloadPersonalInformationProtection } from '../../service'
import { log } from 'util';
import JobPickingModal from '../components/JobPickingModal';
import ConfirmGroupModal from '../components/ConfirmGroupModal';
import AddToGroupNewModal from '../components/AddToGroupNewModal';
import GroupNewModal from '../components/GroupNewModal';
import ConfirmFamilyModal from '../components/ConfirmFamilyModal';
import AddToFamilyNewModal from '../components/AddToFamilyNewModal';
import WarningModal from '../components/WarningModal3';
import SendEmailModal from '../components/SendEmailModal.vue'

export default {
  name: 'CustomerCreate',
  mixins: [commonMixin],
  components: { SearchClientModal, GroupModal, ValidationModal, JobPickingModal, ConfirmGroupModal, AddToGroupNewModal, GroupNewModal, ConfirmFamilyModal, AddToFamilyNewModal, WarningModal, SendEmailModal },
  data() {
    return {
      today: window.moment(),
      jobPickingOpen: false,
      validModalOpen: false,
      groupModalOpen: false,
      clientSearchOpen: false,
      isBirdayError: false,
      address_T: '',
      office_address_T: '',
      householdOpt: [
        { text: '60萬以下', val: '1' },
        { text: '61萬~80萬', val: '2' },
        { text: '81萬~100萬', val: '3' },
        { text: '101萬~150萬', val: '4' },
        { text: '151萬~200萬', val: '5' },
        { text: '201萬~350萬', val: '6' },
        { text: '351萬以上', val: '7' },
      ],
      personalOpt: [
        { text: '無', val: '1' },
        { text: '30萬以下', val: '2' },
        { text: '31~60萬', val: '3' },
        { text: '61~100萬', val: '4' },
        { text: '101~200萬', val: '5' },
        { text: '201萬以上', val: '6' },
      ],
      housingOpt: [
        { text: '自有', val: '1' },
        { text: '租賃', val: '2' },
        { text: '其他親屬所有', val: '3' },
        { text: '其他', val: '4' },
      ],
      investOpt: [
        { text: '無', val: '1' },
        { text: '3千以下', val: '2' },
        { text: '3千~5千', val: '3' },
        { text: '5千~1萬', val: '4' },
        { text: '1萬~2萬', val: '5' },
        { text: '2萬~5萬', val: '6' },
        { text: '5萬以上', val: '7' },
      ],
      vehicleOpt: [
        { text: '無', val: '1' },
        { text: '機車', val: '2' },
        { text: '汽車', val: '3' },
        { text: '機車與汽車', val: '4' },
      ],
      tools: [
        { text: '定存', val: '1' },
        { text: '保險', val: '2' },
        { text: '共同基金', val: '3' },
        { text: '標會', val: '4' },
        { text: '債券', val: '5' },
        { text: '股票', val: '6' },
        { text: '期貨外匯', val: '7' },
        { text: '不動產', val: '8' },
        { text: '其他', val: '9' },
      ],
      careerOpt: [
        { text: '農業', val: '1' },
        { text: '林業', val: '2' },
        { text: '漁業', val: '3' },
        { text: '畜牧業', val: '4' },
        { text: '建築營造業', val: '5' },
        { text: '製造業', val: '6' },
        { text: '貿易業', val: '7' },
        { text: '運輸倉儲業', val: '8' },
        { text: '金融保險業', val: '9' },
        { text: '娛樂運動業', val: '10' },
        { text: '服務業', val: '11' },
        { text: '餐旅美容業', val: '12' },
        { text: '公務員', val: '13' },
        { text: '教育業', val: '14' },
        { text: '軍警業', val: '15' },
        { text: '自由業', val: '16' },
        { text: '家管', val: '17' },
        { text: '學生', val: '18' },
        { text: '無業', val: '19' },
        { text: '中小學以上教師', val: '20' },
        { text: '律師、醫師、會計師、建築師、引水人', val: '21' },
        { text: '電子業', val: '22' },
        { text: '資訊業', val: '23' },
        { text: '其他', val: '24' },
      ],
      eduOpt: [
        { text: '國中及以下', val: '1' },
        { text: '高中/職', val: '2' },
        { text: '專科', val: '3' },
        { text: '大學', val: '4' },
        { text: '研究所以上', val: '5' },
      ],
      marriageOpt: [
        { text: '未婚', val: '1' },
        { text: '已婚', val: '2' },
        { text: '離婚', val: '3' },
        { text: '其他', val: '4' },
      ],
      housingStatusOpt: [
        { text: "獨居", val: "1" },
        { text: "與家人同住", val: "2" },
        { text: "與65歲以上親屬同住", val: "3" },
        { text: "與照顧者或看戶同住", val: "4" },
        { text: "居住於照護機構", val: "5" },
      ],
      agedisable: false,
      birthYearOpt: [],
      birthMonthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      birthDateOpt: [],
      cityOpt: [],
      officeCityOpt: [],
      areaList: [],
      areaOpt: [],
      officeAreaOpt: [],
      form: {
        name: '',
        identityID: '',
        birthday: ['', '', ''],
        gender: '',
        lineid: '',
        mobile: '',
        phone: ['', ''],
        office_phone: ['', '', ''],
        fax_area: '',
        fax: '',
        email: '',
        introducer: '',
        introducerId: '',
        career: '',
        career_name: '',
        careerCategory: '',
        education: '',
        agency: '',
        marriage: '',
        housing_status: "",
        address: ['', '', '', ''],
        office_address: ['', '', '', ''],
        household_income: '',
        personal_income: '',
        houseloan: '',
        housing: '',
        monthly_invest: '',
        finance_tool: [],
        vehicle: '',
        group: [],
        wg_name: '',
        age: '',
        memo: '',
      },
      confirmGroupModalOpen: false,
      addToGroupNewModalOpen: false,
      groupNewModalOpen: false,
      grpsOfAgnt: [],
      confirmFamilyModalOpen: false,
      addToFamilyNewModalOpen: false,
      familyNewModalOpen: false,
      familyOfAgnt: [],
      newCust: {},
      addFamily: [], //家戶
      warningMessage: '',
      warningModalOpen: false,
      sendEmailModalOpen: false,
      mailAttachmentName: "國泰人壽個人資料保護法應告知事項.pdf"
    }
  },
  watch: {
    'form.identityID': function () {
      var length = this.form.identityID.length;
      if (this.form.identityID && length > 0) {
        this.form.identityID = this.form.identityID.toUpperCase();
        var val = this.form.identityID.substring(0, 1);
        if (val == '*') {
          this.form.identityID = val + this.form.identityID.substring(1, length).replace(/[^a-zA-Z0-9]+/g, '');
        } else {
          this.form.identityID = this.form.identityID.replace(/[^a-zA-Z0-9]+/g, '');
        }
      }

      if (length > 1) {
        var sexOfId = this.form.identityID.substr(1, 1);
        if (sexOfId.toUpperCase().match('1|8|A|C')) {
          this.form.gender = '1';
        } else if (sexOfId.toUpperCase().match('2|9|B|D')) {
          this.form.gender = '2';
        }
      }
    },
    'form.lineid': function () {
      this.form.lineid = this.form.lineid.replace(/[^0-9a-zA-Z_\-.@/]+/g, '');
    },
    'form.wg_name': function () {
      //    原住民姓名(拼音)不能輸入中文
      this.form.wg_name = this.form.wg_name.replace(/[\u4e00-\u9fa5]/g, '');
    },
  },
  computed: {
    ...mapGetters(['Cities', 'UserInfo']),
    isBox() {
      return this.UserInfo.userType === 'box';
    },
  },
  methods: {
    //檢查姓名
    checkInputName() {
      this.form.name = this.form.name.replace(/[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g, '');
      if (this.stringBytes(this.form.name, false, 50) > 50) {
        this.form.name = this.form.name.substring(0, this.stringBytes(this.form.name, true, 50));
      }
    },
    //檢查原住民姓名(拼音)
    checkInputWgName() {
      this.form.wg_name = this.form.wg_name.replace(/[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g, '');
      if (this.stringBytes(this.form.wg_name, false, 100) > 100) {
        this.form.wg_name = this.form.wg_name.substring(0, this.stringBytes(this.form.wg_name, true, 100));
      }
    },
    //檢查LINE ID
    checkInputLineID() {
      this.form.lineid = this.form.lineid.replace(/[<>!#$^&,"'?%*:;()+{}[\]|~`=\\]/g, '');
    },
    //檢查Email
    checkInputEmail() {
      this.form.email = this.form.email.replace(/[<>!#$^&,"'?%*:;()+{}[\]|~`=\\]/g, '');
    },
    //檢查服務單位
    checkInputAgency() {
      this.form.agency = this.form.agency.replace(/[<>!@#$^&,"'?%*:;+{}[\]|~`=\\]/g, '');
      if (this.stringBytes(this.form.agency, false, 30) > 30) {
        this.form.agency = this.form.agency.substring(0, this.stringBytes(this.form.agency, true, 30));
      }
    },
    //檢查現居地址
    checkInputAddress() {
      this.form.address[2] = this.full2half(this.form.address[2]);
      this.form.address[2] = this.form.address[2].replace(/[<>()^︿!@#$^&,."'?%*:;+_/{}[\]|~`=\\\s]/g, '');
      if (this.stringBytes(this.form.address[2], false, 50) > 50) {
        this.form.address[2] = this.form.address[2].substring(0, this.stringBytes(this.form.address[2], true, 50));
      }
    },
    //檢查公司地址
    checkInputOfficeAddress() {
      this.form.office_address[2] = this.full2half(this.form.office_address[2]);
      this.form.office_address[2] = this.form.office_address[2].replace(/[<>()^︿!@#$^&,."'?%*:;+_/{}[\]|~`=\\\s]/g, '');
      if (this.stringBytes(this.form.office_address[2], false, 50) > 50) {
        this.form.office_address[2] = this.form.office_address[2].substring(
          0,
          this.stringBytes(this.form.office_address[2], true, 50),
        );
      }
    },
    //全形轉化為半形
    full2half(str) {
      let result = "";
      let len = str.length;
      for (let i = 0; i < len; i++) {
        let cCode = str.charCodeAt(i);
        //全形與半形相差（除空格外）：65248(十進位制)
        if (cCode >= 65281 && 65374 >= cCode) {
          cCode -= 65248;
        } else if (cCode == 12288) { // 全形空白轉半形
          cCode = 32;
        }
        result += String.fromCharCode(cCode);
      }
      return result;
    },
    //檢查備註
    checkInputMemo() {
      this.form.memo = this.form.memo.replace(/[{}[\]§|]/g, '');
      if (this.stringBytes(this.form.memo, false, 400) > 400) {
        this.form.memo = this.form.memo.substring(0, this.stringBytes(this.form.memo, true, 400));
      }
    },
    //  監聽input 只能輸入數字
    numberMobile() {
      this.form.mobile = this.form.mobile.replace(/[^\d]/g, '');
    },
    numberPhone0() {
      this.form.phone[0] = this.form.phone[0].replace(/[^\d]/g, '');
    },
    numberPhone1() {
      this.form.phone[1] = this.form.phone[1].replace(/[^\d]/g, '');
    },
    numberOffice_phone0() {
      this.form.office_phone[0] = this.form.office_phone[0].replace(/[^\d]/g, '');
    },
    numberOffice_phone1() {
      this.form.office_phone[1] = this.form.office_phone[1].replace(/[^\d]/g, '');
    },
    numberOffice_phone2() {
      this.form.office_phone[2] = this.form.office_phone[2].replace(/[^\d]/g, '');
    },
    numberFax_area() {
      this.form.fax_area = this.form.fax_area.replace(/[^\d]/g, '');
    },
    numberFax() {
      this.form.fax = this.form.fax.replace(/[^\d]/g, '');
    },
    numberAge() {
      this.form.age = this.form.age.replace(/[^\d]/g, '');
    },
    numberHouseloan() {
      this.form.houseloan = this.form.houseloan.replace(/[^\d]/g, '');
    },
    ...mapActions(['setPageLock', 'updateCustID', 'updateSerNo']),
    deleteIntr() {
      this.form.introducer = '';
      this.form.introducerId = '';
    },
    removeGroupItem(i) {
      this.form.group.splice(i, 1);
    },
    submitGroup(group) {
      this.form.group.push(group);
      this.panelClose('groupModalOpen');
    },
    submitClient(member) {
      this.form.introducer = member.name;
      this.form.introducerId = member.id;
      this.panelClose('clientSearchOpen');
    },
    initData() {
      let form = this.form;
      for (var key in form) {
        switch (key) {
          case 'birthday':
            form[key] = ['', '', ''];
            break;
          case 'phone':
            form[key] = ['', ''];
            break;
          case 'office_phone':
            form[key] = ['', '', ''];
            break;
          case 'address':
            form[key] = ['', '', ''];
            break;
          case 'office_address':
            form[key] = ['', '', ''];
            break;
          case 'finance_tool':
            form[key] = ['0', '0', '0', '0', '0', '0', '0', '0', '0'];
            break;
          case 'group':
            form[key] = [];
            break;
          default:
            form[key] = '';
        }
      }
    },
    updateDate() {
      let year = this.form.birthday[0];
      let month = this.form.birthday[1];
      if (!year || !month) return;
      // this.form.birthday[0] = 1986 //預設會員為75年
      let dt = new Date(year, month, 0).getDate();
      this.birthDateOpt = [];
      for (var i = 0; i < dt; i++) {
        this.birthDateOpt.push(i + 1);
      }
    },
    changeCity(key) {
      if (key === 'address' && this.form.address[0].length > 0) {
        queryDistByCity(this.$store.state.userInfo.id, this.form.address[0]).then(result => {
          this.areaOpt = result.body.cityAreaList.map(item => {
            return { area: item.AREA, city: item.CITY, zipcode: item.ZIPCODE };
          });
          this.form.address[1] = '';
          this.form.address[2] = '';
        });

        // this.areaOpt = [{city: '台北市', area:'中正區', zipcode: '022'}, {city: '台北市', area:'大同區', zipcode: '011'}]
      } else if (key === 'office_address' && this.form.office_address[0].length > 0) {
        queryDistByCity(this.$store.state.userInfo.id, this.form.office_address[0]).then(result => {
          this.officeAreaOpt = result.body.cityAreaList.map(item => {
            return { area: item.AREA, city: item.CITY, zipcode: item.ZIPCODE };
          });
          this.form.office_address[1] = '';
          this.form.office_address[2] = '';
        });
        // this.officeAreaOpt = [{city: '台北市', area:'中正區', zipcode: '022'}, {city: '台北市', area:'大同區', zipcode: '011'}]
      }
      // let index = 0
      // this.Cities.forEach((c, i) => {
      //   if (c.city === this.form[key]) index = i
      // })
      // if (key === 'address') {
      //   this.areaOpt = this.areaList[index]
      // }
      // if (key === 'office_address') {
      //   this.officeAreaOpt = this.areaList[index]
      // }
    },
    checkName() {
      // 不能空 也不能為特殊符號
      let pattern = /[<>!@#$^&,."'?%*;_()+-/{}[\]|~`=\\\s]/g;
      let isNonEmpty = this.form.name.trim().length > 0;
      let isFormatCurrect = this.form.name.match(pattern) == null;
      return isNonEmpty && isFormatCurrect;
      // return true
    },
    checkWgName() {
      if (this.form.wg_name == '') {
        return true;
      }
      // let wgNamePattern = /^[a-zA-Z\s\:\넖\넗\넘\넙\넚\넛]+$/
      //big5編碼 A88F , A890 , A891 , A892 , A893 , A894
      // return wgNamePattern.test(this.form.wg_name)
      return true;
    },
    checkLine() {
      if (this.form.lineid == '') {
        return true;
      }
      let linePattern = /^[A-Za-z0-9@_\-./]+$/;
      return linePattern.test(this.form.lineid);
    },
    checkMobile() {
      if (this.form.mobile == '') {
        return true;
      }
      let mobilePattern = new RegExp('^[0-9]{10}$');
      return mobilePattern.test(this.form.mobile);
    },
    checkPhone(target) {
      let phoneAreaPattern = new RegExp('^0[0-9]{1,4}$');
      let phonePattern = new RegExp('^[0-9]{4,20}$');
      let extPattern = /^[0-9]{0,10}$/;
      switch (target) {
        case 'home':
          if (this.form.phone[0] == '' && this.form.phone[1] == '') {
            return true;
          }
          return phoneAreaPattern.test(this.form.phone[0]) && phonePattern.test(this.form.phone[1]);
        case 'office':
          if (this.form.office_phone[0] == '' && this.form.office_phone[1] == '' && this.form.office_phone[2] == '') {
            return true;
          }
          return (
            phoneAreaPattern.test(this.form.office_phone[0]) &&
            phonePattern.test(this.form.office_phone[1]) &&
            extPattern.test(this.form.office_phone[2])
          );
        default:
          return false;
      }
    },
    checkAddr() {
      //確認地址是不是有特殊字元
      let addr = true;
      let addrOffice = true;
      let pattern = /[<>!@#$^&,."'?%*:;+_/{}[\]|~`=\\]/g;
      if (this.form.address[2]) {
        addr = this.form.address[2].match(pattern) == null;
      }
      if (this.form.office_address[2]) {
        addrOffice = this.form.office_address[2].match(pattern) == null;
      }
      return addr && addrOffice;
    },
    checkEmail() {
      if (this.form.email == '') {
        return true;
      } else {
        let emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailPattern.test(this.form.email);
      }
    },
    checkFaxPhone() {
      if (this.form.fax_area == '' && this.form.fax == '') {
        return true;
      } else {
        let faxAreaPattern = new RegExp('^0[1-9]{2,5}$');
        let faxPattern = new RegExp('^[0-9]{4,20}$');

        let allResult = [faxAreaPattern.test(this.form.fax_area), faxPattern.test(this.form.fax)];
        return allResult.indexOf(false) === -1;
      }
    },
    checkWordNum() {
      // 判斷輸入欄位字數是否超過限制
      if (
        this.form.name.length > 50 ||
        this.form.wg_name.length > 100 ||
        this.form.identityID.length > 10 ||
        this.form.lineid.length > 20 ||
        this.form.mobile.length > 20 ||
        this.form.phone[0].length > 5 ||
        this.form.phone[1].length > 20 ||
        this.form.office_phone[0].length > 5 ||
        this.form.office_phone[1].length > 15 ||
        this.form.office_phone[2].length > 10 ||
        this.form.email.length > 50 ||
        this.form.agency.length > 30 ||
        this.form.address[2].length > 50 ||
        this.form.office_address[2].length > 50 ||
        this.form.fax_area.length > 5 ||
        this.form.fax.length > 20 ||
        this.form.houseloan.length > 10
      ) {
        return false;
      } else {
        return true;
      }
    },
    checkContactInfoIsAllEmpty() {
      let isLineEmpty = this.form.lineid == '';
      let isMobileEmpty = this.form.mobile == '';
      let isPhoneEmpty = this.form.phone[0] == '' && this.form.phone[1] == '';
      let isOfficePhoneEmpty =
        this.form.office_phone[0] == '' && this.form.office_phone[1] == '' && this.form.office_phone[2] == '';
      return isLineEmpty && isMobileEmpty && isPhoneEmpty && isOfficePhoneEmpty;
    },
    checkBirthdayAgeAllEmpty() {
      let isAgeEmpty = this.form.age == '';
      let isBirthdayEmpty = this.form.birthday[0] == '' || this.form.birthday[1] == '' || this.form.birthday[2] == '';
      return isBirthdayEmpty && isAgeEmpty;
    },
    computeBirAge(year, month, day) {
      // 計算保險年齡
      this.updateDate();
      if (year !== '' && month !== '' && day !== '') {
        this.form.age = '';
        if (month < 10) {
          month = '0' + month;
        }
        if (day < 10) {
          day = '0' + day;
        }
        computeAge(this.$store.state.userInfo.id, `${year}-${month}-${day}`).then(result => {
          if (result.header && result.header.status == '200') {
            this.form.age = result.body.age;
          } else {
            this.form.age = '計算錯誤';
          }
        });
        this.agedisable = true;
        this.form.age = '計算中...';
      } else {
        this.form.age = '';
        this.agedisable = false;
      }
    },
    doSubmit() {
      if (!this.checkWordNum()) {
        return this.$toast.info({ title: '欄位總字數超過限制' });
      }
      let checkNameMsg = this.checkName() ? '' : '姓名不能為空不能有特殊符號';
      let checkWgNameMsg = this.checkWgName() ? '' : '原住民名不能為空不能有特殊符號';
      let checkAddrMsg = this.checkAddr() ? '' : '地址不能有特殊字元或空白字元';
      let checkLineMsg = this.checkLine() ? '' : 'line不能有特殊字元或空白字元';
      let checkMobileMsg = this.checkMobile() ? '' : '手機格式錯誤';
      let checkHomePhoneMsg = this.checkPhone('home') ? '' : '住家電話格式錯誤';
      let checkOfficePhoneMsg = this.checkPhone('office') ? '' : '公司電話格式錯誤';
      let checkEmailMsg = this.checkEmail() ? '' : 'Email格式錯誤';
      let checkFaxPhoneMsg = this.checkFaxPhone() ? '' : '傳真格式錯誤';
      //let checkBirthdayAgeMsg =  this.checkBirthdayAgeAllEmpty()? '生日或年齡不能全為空': ''
      //不卡聯絡資訊四選一
      //let  checkContactInfoMsg = this.checkContactInfoIsAllEmpty()? '聯絡資訊不能全為空': ''

      let toastMsg = [
        checkNameMsg,
        checkWgNameMsg,
        checkAddrMsg,
        checkLineMsg,
        checkMobileMsg,
        checkHomePhoneMsg,
        checkOfficePhoneMsg,
        checkEmailMsg,
        checkFaxPhoneMsg,
      ]
        .filter(msg => {
          return msg != '';
        })
        .join(',');

      if (toastMsg == '') {
        let insertData = Object.assign({}, this.form);
        let defaultFinanceTool = ['0', '0', '0', '0', '0', '0', '0', '0', '0'];
        this.form.finance_tool.map(item => (defaultFinanceTool[Number(item) - 1] = item));
        insertData.finance_tool = defaultFinanceTool.join(''); //理財工具

        let areaOptObj = this.areaOpt.filter(item => item.area == this.form.address[1])[0];
        insertData.address[3] = areaOptObj ? areaOptObj.zipcode : ''; //地址

        let officeAreaOptObj = this.officeAreaOpt.filter(item => item.area === this.form.office_address[1])[0];
        insertData.office_address[3] = officeAreaOptObj ? officeAreaOptObj.zipcode : ''; //公司地址
        let month =
          insertData.birthday[1].toString().length == 1
            ? '0' + insertData.birthday[1].toString()
            : insertData.birthday[1].toString();
        let date =
          insertData.birthday[2].toString().length == 1
            ? '0' + insertData.birthday[2].toString()
            : insertData.birthday[2].toString();
        insertData.birthday = [insertData.birthday[0].toString(), month, date];

        //檢核生日
        this.isBirdayError = false;
        let birthdayString = insertData.birthday[0].toString() + "-" + month + "-" + date + " 00:00:00";
        if (insertData.birthday[0].toString() && !moment(birthdayString).isSameOrBefore(moment(), "day")) {
          this.$toast.info({ title: "出生日期不得超過今日" });
          this.isBirdayError = true; ''
          return false;
        }
        addNewCust(this.$store.state.userInfo.id, insertData, 'ADD_CUSTOMER').then(result => {
          if (result.header && result.header.status && result.header.status === '200') {
            this.$toast.info({ title: `${result.header.message}` })
            this.address_T = this.form.address[0] + this.form.address[1] + this.form.address[2];
            this.office_address_T = this.form.office_address[0] + this.form.office_address[1] + this.form.office_address[2];
            //寫入log(近期新增客戶)
            let logData = {
              agnt_id: this.$store.state.userInfo.id,
              cust_id: result.body.ser_no ? result.body.ser_no : this.form.identityID,
              cust_name: this.form.name,
              act_type: "I"
            };
            addCustInfoLog(this.$store.state.userInfo.id, logData);
            //設定寫入家戶欄位
            this.addFamily.birthday = this.getBirthdayString();
            this.addFamily.age = this.form.age;
            let newFamily = [];
            let newCustID = "";
            if (result.body.ser_no) {  //如果客戶是無 ID
              newCustID = result.body.ser_no; //無ID回傳的客戶流水號
              if (this.addFamily.newFamilyId) {
                this.addFamily.csidno = newCustID;
                newFamily.push(this.addFamily);
                //加入家戶(無ID)
                this.addFamily.newFamilyId == "createNewFamily" ? createNewFamily(this.UserInfo.id, newCustID, newFamily) : addMembersToFamily(this.UserInfo.id, this.addFamily.newFamilyId, newFamily);
              }
              this.AddLatAndLntToDB('', newCustID);
              if (this.isBox) {
                this.boxCustInfo(newCustID, this.form.name);
              } else {
                this.updateSerNo(newCustID);
                this.updateCustID('');
                localStorage.SerNo = newCustID;
                localStorage.CustID = '';
                this.$router.push({ path: `/detail/SerNo/tab/1` });
              }
            } else {                   //如果客戶有 ID
              if (this.addFamily.newFamilyId) {
                this.addFamily.csidno = this.form.identityID;
                newFamily.push(this.addFamily);
                //加入家戶(有ID)
                this.addFamily.newFamilyId == "createNewFamily" ? createNewFamily(this.UserInfo.id, this.form.identityID, newFamily) : addMembersToFamily(this.UserInfo.id, this.addFamily.newFamilyId, newFamily);
              }
              this.AddLatAndLntToDB(this.form.identityID, '');
              if (this.isBox) {
                this.boxCustInfo(this.form.identityID, this.form.name);
              } else {
                this.updateCustID(this.form.identityID);
                this.updateSerNo('');
                localStorage.SerNo = '';
                localStorage.CustID = this.form.identityID;
                this.$router.push({ path: `/detail/CustID/tab/1` });
              }
            }
          } else {
            if (result.header && result.header.message) {
              this.$toast.info({ title: `${result.header.message}` });
            } else {
              this.$toast.info({ title: `新增客戶失敗` });
            }
          }
        });
      } else {
        this.$toast.info({ title: toastMsg });
      }
      // if (
      //   this.form.name==='' ||
      //   (this.form.lineid==='' && this.form.mobile==='' && this.form.phone && this.form.office_phone)
      // ) {
      //   this.panelOpen('validModalOpen')
      // } else {
      //   this.$router.push('/detail/1/empty')
      //   this.$toast.info({title: '「新增客戶」已完成'})
      // }
    },
    AddLatAndLntToDB(ID, ser_no) {
      let key = '';
      if (ID) {
        key = ID;
      } else {
        key = ser_no;
      }
      //新增現居地址經緯度(type=1)
      if (this.address_T) {
        AddLatAndLnt(this.$store.state.userInfo.id, key, this.address_T, '1').then(result => {
          if (result.header && result.header.status && result.header.status === '200') {
            //this.$toast.info({title: `${result.header.message}`})
          } else {
            this.$toast.info({ title: `新增客戶成功但新增現居地址經緯度失敗` });
          }
        });
      }
      //新增公司地址經緯度(type=2)
      if (this.office_address_T) {
        AddLatAndLnt(this.$store.state.userInfo.id, key, this.office_address_T, '2').then(result => {
          if (result.header && result.header.status && result.header.status === '200') {
            //this.$toast.info({title: `${result.header.message}`})
          } else {
            this.$toast.info({ title: `新增客戶成功但新增公司地址經緯度失敗` });
          }
        });
      }
    },
    submitJob(job) {
      this.form.career_name = job.job_name;
      this.form.careerCategory = job.job_cat;
      this.form.career = job.job_code;
      this.jobPickingOpen = false;
    },
    stringBytes(c, isSub, size) {
      //計算字元長度 (字串, 是否檢查, 檢查的長度)
      var n = c.length,
        s;
      var len = 0;
      for (var i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
    initGroupOfAgent() {
      //取得當前業務員的所有群組資料
      getGroupOfAgnt(this.$store.state.userInfo.id, this.$store.state.userInfo.id, 0).then(result => {
        const transformedDate = [];
        if (result.body && result.body.groups) {
          result.body.groups.forEach(grp => {
            const data = {
              grp_id: grp.grp_id,
              grp_name: grp.grp_name,
            };
            transformedDate.push(data);
          });
          this.grpsOfAgnt = transformedDate;
        } else {
          this.grpsOfAgnt = transformedDate;
        }
      });
    },
    //加入現有群組
    addToGrpSubmit(newSelectedGroups) {
      if (newSelectedGroups && newSelectedGroups.length > 0) {
        this.form.group = [];
        newSelectedGroups.forEach(item => {
          this.form.group.push(item);
        });
      }
      this.panelClose('addToGroupNewModalOpen');
    },
    //成立新的群組
    groupSubmit(newGroups) {
      this.$toast.info({ title: '編輯客戶所屬群組成功' });
      newGroups.forEach(item => {
        this.form.group.push(item);
      });
      this.panelClose('groupNewModalOpen');
      this.initGroupOfAgent();
    },
    //開啟加入至現有群組視窗
    addToCurrentGroup() {
      this.panelClose('confirmGroupModalOpen');
      this.panelOpen('addToGroupNewModalOpen');
    },
    //開啟成立新的群組視窗
    createNewGroup() {
      this.panelClose("confirmGroupModalOpen");
      this.panelOpen("groupNewModalOpen");
    },
    //取得當前業務員的所有家戶資料
    initFamilyOfAgent() {
      getAllHouseholderBySales(this.UserInfo.id).then(result => {
        let familyList = [];
        this.mxMaskOpen = false;
        if (result.header && result.header.status == "200") {
          result.data.forEach(item => {
            let data = {
              age: item.age == undefined ? "" : item.age + "歲" || "",
              id: item.csidno,
              showid: item.csidno.includes("~") || item.csidno.includes("#") ? "" : item.csidno,
              birthday: item.birthday || "",
              familymemberid: item.familymemberid || "",
              name: item.name || "",
              sex: item.sex || "",
              vip_lvl: item.vip_lvl || ""
            };
            familyList.push(data);
          });
        } else {
          console.error("取得家戶資料失敗>>", result.header.message);
        }
        this.familyOfAgnt = familyList;
      });
    },
    //加入現有家戶
    addToFamilySubmit(newFamily) {
      this.addFamily = newFamily;
      this.panelClose("addToFamilyNewModalOpen");
    },
    //開啟加入家戶視窗
    doAddFamily() {
      if (this.checkFamilyColumn()) {
        return;
      }
      this.createNewCustForFamily();
      this.panelOpen("confirmFamilyModalOpen");
    },
    //清空家戶
    doCleanFamily() {
      this.addFamily = [];
    },
    //開啟加入至現有家戶視窗
    addToCurrentFamily() {
      this.panelClose("confirmFamilyModalOpen");
      this.panelOpen("addToFamilyNewModalOpen");
    },
    //成立新的家戶
    createNewFamily() {
      this.panelClose("confirmFamilyModalOpen");
      this.addFamily = this.newCust;
      this.addFamily.familyrl = 0;
      this.addFamily.familyName = this.newCust.name;
      this.addFamily.newFamilyId = "createNewFamily";
    },
    //檢查家戶相關欄位
    checkFamilyColumn() {
      let chkArr = [];
      let flag = false;
      if (!this.form.name) {
        chkArr.push("「姓名」");
      }
      if (!this.form.gender) {
        chkArr.push("「性別」");
      }
      if (
        !this.form.birthday[0] &&
        !this.form.birthday[1] &&
        !this.form.birthday[2] &&
        !this.form.age
      ) {
        chkArr.push("「生日或年齡」");
      }

      if (chkArr.length) {
        flag = true;
        let msg = "";
        for (let i = 0; i < chkArr.length; i++) {
          msg += chkArr[i] + "、";
        }
        msg = "缺少" + msg.substring(0, msg.length - 1) + "，無法建立家戶";
        this.setToastMsg(msg);
      }
      return flag;
    },
    //產生新客戶資料(家戶用)
    createNewCustForFamily() {
      this.newCust = {
        agidno: this.UserInfo.id,
        name: this.form.name,
        sex: this.form.gender,
        sexText: this.form.gender == "1" ? "男" : "女",
        birthday: this.getBirthdayString(),
        age: this.form.age
      };
    },
    //取得生日欄位
    getBirthdayString() {
      let birthday = "";
      if (this.form.birthday[0] && this.form.birthday[1] && this.form.birthday[2]) {
        let month =
          this.form.birthday[1].toString().length == 1
            ? "0" + this.form.birthday[1].toString()
            : this.form.birthday[1].toString();
        let date =
          this.form.birthday[2].toString().length == 1
            ? "0" + this.form.birthday[2].toString()
            : this.form.birthday[2].toString();
        birthday = this.form.birthday[0] + "-" + month + "-" + date;
      }
      return birthday;
    },
    popUpWarning() {
      this.warningMessage = '為確保客戶(潛在客戶)個人資料權益，請告知以下內容，並確實取得同意，為其進行資料建檔。'
      this.panelOpen('warningModalOpen')
    },
    openSendEmailModal() {
      this.panelClose("warningModalOpen");
      this.panelOpen('sendEmailModalOpen');
    },
    closeEmailModal() {
      this.panelClose("sendEmailModalOpen");
      this.panelOpen('warningModalOpen');
    },
    doSendEmail(form) {
      sendDataCollectionEmail(this.$store.state.userInfo.id, form, this.mailAttachmentName).then(
        result => {
          if (result.header && result.header.status === "200") {
            this.setToastMsg(result.header.message);
          } else {
            this.setToastMsg(result.header.message);
          }
        });
    },
    download() {
      let newWindow;
      if (!this.isBox) {
        newWindow = window.open("/crm/assets/common/ajax-loader.gif")
      }
      downloadPersonalInformationProtection(this.$store.state.userInfo.id, this.mailAttachmentName).then(
        result => {
          let arrayBuffer = new Uint8Array(result.file).buffer;
          if (this.isBox) {
            this.boxSendBase64PdfData(arrayBuffer);
          } else {
            let file = new Blob([arrayBuffer], { type: "application/pdf" });
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(file, this.mailAttachmentName);
            } else {
              newWindow.location = URL.createObjectURL(file);
            }
          }
        }
      );
    },
    doBack() {
      this.panelClose('warningModalOpen')
      this.$router.back();
    }
  },
  mounted() {
    this.popUpWarning()
    let start = this.today.year();
    // let end = this.today.year() - 18

    // for(var i = start; i < end; i++) {
    //   this.birthYearOpt.push(i)
    // }
    this.birthYearOpt = Array.apply(null, { length: 101 }).map(function (value, index) {
      return start - index;
    });

    // this.Cities.forEach(ci => {
    //   this.cityOpt.push(ci.city)
    //   this.officeCityOpt.push(ci.city)
    //   this.areaList.push(ci.area)
    // })
    this.cityOpt = this.Cities.map(item => item.city);
    this.officeCityOpt = this.Cities.map(item => item.city);
    this.areaList = this.Cities.map(item => item.city);

    this.updateDate();
    this.changeCity('address');
    this.changeCity('office_address');
    this.$validator.localize('zh_TW');
    this.registerHanlink();
    // this.$validator.localize('zh_TW', {
    //   messages: {
    //     required: (field) => '* ' + field + ' is required'
    //   },
    //   attributes: {
    //     // email: '信箱'
    //   }
    // })
    this.initGroupOfAgent();
    this.initFamilyOfAgent();
  }
}
</script>

<style scoped>
.boxPadding {
  padding-top: 0px !important;
}

.padding-25 {
  padding-left: 25px;
  padding-right: 25px;
}
</style>
